import React from 'react';

import styled from 'styled-components';
import { OverlayView } from '@react-google-maps/api';
import { Spring } from 'react-spring/renderprops';

import carIcon from './images/car.png';
import { LatLngStatic } from '../common/entities';
import imageExists from 'image-exists';

const springConfig = {
    duration: 3000,
};

const DriverMarkerContainer = styled.img`
    display: flex;
    height: 50px;
    width: 25px;
    margin-left: -12px;
    margin-top: -30px;
    transform: rotate(${(props) => props.heading || 0}deg);
`;

const DriverMarker = (props: any) => {
    const { image, position, bearing } = props;
    if (!position) {
        return null;
    }
    let icon = carIcon;
    imageExists(image, function (exists) {
        if (exists) {
            icon = image;
        }
    });
    return (
        <Spring to={{ ...position, bearing, icon }} config={springConfig}>
            {(springProps) => (
                <OverlayView
                    position={new LatLngStatic(springProps.lat, springProps.lng)}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                    <DriverMarkerContainer src={icon} heading={springProps.bearing} />
                </OverlayView>
            )}
        </Spring>
    );
};

export default DriverMarker;
